import React from 'react';
import SVGLoader from './SVGLoader';

const AudioPauseIcon = ({ ...rest }) => {
  return (
    <SVGLoader
      viewboxHeight={16}
      viewboxWidth={16}
      width={16}
      height={16}
      {...rest}
    >
      <path
        d="M3.3125 1.125H5.8125C5.8125 1.125 6.75 1.125 6.75 2.0625V13.9375C6.75 13.9375 6.75 14.875 5.8125 14.875H3.3125C3.3125 14.875 2.375 14.875 2.375 13.9375V2.0625C2.375 2.0625 2.375 1.125 3.3125 1.125Z"
        fill="currentColor"
      />
      <path
        d="M10.1875 1.125H12.6875C12.6875 1.125 13.625 1.125 13.625 2.0625V13.9375C13.625 13.9375 13.625 14.875 12.6875 14.875H10.1875C10.1875 14.875 9.25 14.875 9.25 13.9375V2.0625C9.25 2.0625 9.25 1.125 10.1875 1.125Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default AudioPauseIcon;
